import React from 'react';
import { UseFormRegister } from 'react-hook-form';

import IInputs from '../../../interfaces/IInputs';
import IRules from '../../../interfaces/IRules';
import './InputSocial.sass';

interface Props {
	inputName: 'facebookLink' | 'linkedinLink' | 'twitterLink';
	placeholder: string;
	Icon: React.FC;
	link: string;
	register: UseFormRegister<IInputs>;
	rules: IRules;
	invalid?: boolean;
	valid?: boolean;
}

function InputSocial({
	inputName,
	register,
	placeholder,
	Icon,
	link,
	rules,
	invalid,
	valid,
}: Props) {
	return (
		<div className="input-social-row">
			<input
				type="text"
				{...register(inputName, rules)}
				id={inputName}
				placeholder={placeholder}
				className={`input-social-default${invalid ? ' invalid' : ''}${
					valid ? ' valid' : ''
				}`}
			/>
			<a
				href={link}
				rel="noreferrer"
				className="input-social-icon"
				target="_blank"
			>
				<Icon />
			</a>
		</div>
	);
}

InputSocial.defaultProps = {
	valid: false,
	invalid: false,
};

export default InputSocial;
